import axios from 'axios'

const API_KEY    = process.env.VUE_APP_API_KEY
const apiBaseUrl = process.env.VUE_APP_API

export const apiEvento = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept':        'application/json',
  },
})

apiEvento.interceptors.request.use(config => {
  if (API_KEY) {
    config.headers['x-api-key'] = API_KEY
  }

  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, error => Promise.reject(error))


// ─────────────────────────────────────────────────────────────────────────────
// EVENTO ACTIVO
// ─────────────────────────────────────────────────────────────────────────────
export const getEventoActivo = async () => {
  try {
    const response = await apiEvento.get('evento/activo/')
    return response.data
  } catch (error) {
    console.error('Error fetching evento activo:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// PELEADORES CONFIRMADOS
// ─────────────────────────────────────────────────────────────────────────────
export const getPeleadoresConfirmados = async () => {
  try {
    const response = await apiEvento.get('evento/activo/peleadores/')
    return Array.isArray(response.data)
      ? response.data
      : response.data?.results || []
  } catch (error) {
    console.error('Error fetching peleadores confirmados:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// PELEADORES DISPONIBLES
// ─────────────────────────────────────────────────────────────────────────────
export const getPeleadoresDisponibles = async () => {
  try {
    const response = await apiEvento.get('evento/activo/peleadores/disponibles/')
    return Array.isArray(response.data)
      ? response.data
      : response.data?.results || []
  } catch (error) {
    console.error('Error fetching peleadores disponibles:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// TIPOS DE BOLETO
// ─────────────────────────────────────────────────────────────────────────────
export const getTiposBoleto = async () => {
  try {
    const response = await apiEvento.get('evento/activo/boletos/')
    return Array.isArray(response.data)
      ? response.data
      : response.data?.results || []
  } catch (error) {
    console.error('Error fetching tipos de boleto:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// PATROCINADORES CONFIRMADOS
// ─────────────────────────────────────────────────────────────────────────────
export const getPatrocinadoresConfirmados = async () => {
  try {
    const response = await apiEvento.get('evento/activo/patrocinadores/')
    return Array.isArray(response.data)
      ? response.data
      : response.data?.results || []
  } catch (error) {
    console.error('Error fetching patrocinadores:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// CARTELERA DE COMBATES
// ─────────────────────────────────────────────────────────────────────────────
export const getCombatesPublicos = async () => {
  try {
    const response = await apiEvento.get('evento/activo/combates/')
    return Array.isArray(response.data)
      ? response.data
      : response.data?.results || []
  } catch (error) {
    console.error('Error fetching combates:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// ASISTENTES DE PELEADOR (ESQUINA)
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Registro público de asistente/esquina de un peleador.
 * Sin restricción de correo: la misma persona puede registrarse varias
 * veces, una por cada peleador al que asiste.
 * @param {{ nombre: string, apellido: string, correo: string, peleador: number }} payload
 */
export const registrarAsistentePeleador = async (payload) => {
  try {
    const response = await apiEvento.post('peleadores/asistentes/', payload)
    return response.data
  } catch (error) {
    console.error('Error registrando asistente de peleador:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// INSCRIPCIÓN DE PELEADOR
// ─────────────────────────────────────────────────────────────────────────────
export const inscribirPeleador = async (formData) => {
  try {
    const response = await apiEvento.post('peleadores/inscripcion/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  } catch (error) {
    console.error('Error en inscripción de peleador:', error)
    throw error
  }
}

// ─────────────────────────────────────────────────────────────────────────────
// COMPRA DE BOLETOS — STRIPE
// ─────────────────────────────────────────────────────────────────────────────
export const iniciarCompraBoleto = async (payload) => {
  try {
    const response = await apiEvento.post('boletos/compra/', payload)
    return response.data
  } catch (error) {
    console.error('Error iniciando compra de boleto:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// REGISTRO DE INVITADOS
// ─────────────────────────────────────────────────────────────────────────────

export const getDetalleInvitado = async (token) => {
  try {
    const response = await apiEvento.get(`boletos/invitado/${token}/`)
    return response.data
  } catch (error) {
    if (error.response?.status === 404) return null
    throw error
  }
}

export const registrarInvitado = async (token, formData) => {
  try {
    const response = await apiEvento.post(`boletos/invitado/${token}/registrar/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  } catch (error) {
    console.error('Error registrando invitado:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// CAMPAÑA: SELECCIÓN DE PELEADOR PENDIENTE (backfill histórico)
// ─────────────────────────────────────────────────────────────────────────────

/**
 * El 410 (ya registrado) se devuelve como dato normal ({ completo: true, ... })
 * en vez de lanzar, para que el componente no tenga que distinguir 410 de 404.
 */
export const getDetallePeleadorPendiente = async (token) => {
  try {
    const response = await apiEvento.get(`boletos/peleador-pendiente/${token}/`)
    return response.data
  } catch (error) {
    if (error.response?.status === 410) return error.response.data
    throw error
  }
}

/**
 * @param {string} token
 * @param {{ selecciones: { compra_id: number, peleador_id: number }[] }} payload
 */
export const registrarPeleadorPendiente = async (token, payload) => {
  try {
    const response = await apiEvento.post(`boletos/peleador-pendiente/${token}/registrar/`, payload)
    return response.data
  } catch (error) {
    console.error('Error registrando selección de peleador:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// STREAMING — AUTENTICACIÓN
// ─────────────────────────────────────────────────────────────────────────────
export const streamingLogin = async ({ email, password }) => {
  try {
    const response = await apiEvento.post('streaming/login/', { email, password })
    return response.data
  } catch (error) {
    console.error('Error en streaming login:', error)
    throw error
  }
}

export const streamingLogout = async (jti) => {
  try {
    const response = await apiEvento.post('streaming/logout/', { jti })
    return response.data
  } catch (error) {
    console.error('Error en streaming logout:', error)
    throw error
  }
}

export const validarSesionStreaming = async (jti) => {
  try {
    const response = await apiEvento.get('streaming/sesion/', { params: { jti } })
    return response.data
  } catch (error) {
    if (error.response?.status === 400) return { valido: false }
    console.error('Error validando sesion streaming:', error)
    throw error
  }
}

/**
 * Consulta si el Live Input de Cloudflare está recibiendo señal real en
 * este momento (camarógrafo conectado), para decidir si mostrar el video
 * comercial de espera o la transmisión real.
 */
export const getEstadoTransmision = async () => {
  try {
    const response = await apiEvento.get('streaming/estado/')
    return response.data  // { en_vivo: boolean }
  } catch (error) {
    console.error('Error consultando estado de transmisión:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// STAFF — LOGIN Y ESCANEO QR
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Login del guardia con JWT.
 * NOTA: ajusta la URL si el prefijo de users es diferente en tu urls.py principal.
 * Ejemplo: si está en /api/v1/users/login/ y apiBaseUrl ya incluye /api/v1/
 * entonces la ruta relativa es 'users/login/'
 */
export const loginStaff = async ({ email, password }) => {
  try {
    const response = await apiEvento.post('auth/login/', { email, password })
    return response.data  // { access, refresh, user: { email, nombre, role } }
  } catch (error) {
    console.error('Error en login staff:', error)
    throw error
  }
}

/**
 * Escanea el QR del asistente con el token_acceso embebido en el QR.
 * Manda el JWT del staff en el header para autenticar la petición.
 */
export const escanearBoleto = async (tokenAcceso) => {
  const access = localStorage.getItem('staff_access')
  try {
    const response = await apiEvento.post(
      `boletos/escanear/${tokenAcceso}/`,
      {},
      { headers: { Authorization: `Bearer ${access}` } }
    )
    return response.data  // { valido, nombre, tipo_boleto, es_menor, foto_url, hora_acceso }
  } catch (error) {
    console.error('Error escaneando boleto:', error)
    throw error
  }
}

/**
 * Escanea el pase de identificación (gafete) de un peleador o asistente de
 * peleador. Reutilizable — a diferencia del boleto, no marca "ya usado".
 */
export const escanearGafete = async (tokenGafete) => {
  const access = localStorage.getItem('staff_access')
  try {
    const response = await apiEvento.post(
      `gafetes/escanear/${tokenGafete}/`,
      {},
      { headers: { Authorization: `Bearer ${access}` } }
    )
    return response.data  // { valido, tipo, nombre, rol_display?, equipo?, foto_url?, peleador_asociado? }
  } catch (error) {
    console.error('Error escaneando gafete:', error)
    throw error
  }
}